import { CheckCircle2, Clock } from "lucide-react";

import { brl } from "../lib/periodos";

const dataBR = (iso) => (iso ? iso.split("-").reverse().slice(0, 2).join("/") : "");

function Despesa({ d }) {
  return (
    <div className="flex items-center gap-3 pl-14 pr-4 py-1.5 text-xs bg-muted/10 hover:bg-muted/30" data-e2e="dre-despesa">
      <span className="w-11 shrink-0 tabular-nums text-muted-foreground">{dataBR(d.data)}</span>
      <span className="flex-1 min-w-0 truncate">
        {d.nome}
        {d.fornecedor ? <span className="text-muted-foreground"> · {d.fornecedor}</span> : null}
      </span>
      {d.pago
        ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 shrink-0" title="Paga" />
        : <Clock className="w-3.5 h-3.5 text-amber-600 shrink-0" title="A pagar" />}
      <span className="tabular-nums w-24 sm:w-32 shrink-0 whitespace-nowrap text-right text-muted-foreground">{brl(d.valor)}</span>
    </div>
  );
}

/**
 * O que forma o número da linha. Despesas: cada classificação com o subtotal e,
 * embaixo, cada despesa lançada (data, nome, fornecedor, paga ou não). Taxas:
 * cada forma de pagamento com quanto vendeu e quanto pagou de taxa.
 */
export default function DetalheDre({ detalhe }) {
  return detalhe.map((g, i) => (
    <div key={`${g.classificacao}-${i}`}>
      <div className="flex items-center gap-3 pl-11 pr-4 py-1.5 text-xs font-semibold bg-muted/25">
        <span className="flex-1 truncate">
          {g.classificacao}
          <span className="font-normal text-muted-foreground">
            {g.vendas != null ? ` · taxa sobre ${brl(g.vendas)} em ${g.lancamentos} venda(s)` : g.lancamentos ? ` · ${g.lancamentos} lançamento(s)` : ""}
          </span>
        </span>
        <span className="tabular-nums w-24 sm:w-32 shrink-0 whitespace-nowrap text-right">{brl(g.valor)}</span>
      </div>
      {(g.itens || []).map((d) => <Despesa key={d.id} d={d} />)}
    </div>
  ));
}
